import React from 'react'
import ReactDOM from 'react-dom'

import App from './App'

import 'antd/dist/antd.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-daterangepicker/daterangepicker.css'

ReactDOM.render(<App />, document.getElementById('root'))
